import { createPortal } from 'react-dom';

interface ConfirmationModalProps<IsForm extends boolean = false> {
  isOpen: boolean;
  formID?: IsForm extends true ? string : undefined;
  header?: React.ReactNode;
  content?: React.ReactNode;
  isLoading?: boolean;
  isDisabled?: boolean;
  onCancel: () => void;
  onConfirm?: IsForm extends true ? undefined : () => void | Promise<void>;
  isForm?: IsForm;
}

function ConfirmationModal<IsForm extends boolean = false>({
  isOpen,
  formID,
  header,
  content,
  isLoading,
  isDisabled,
  onCancel,
  onConfirm,
}: ConfirmationModalProps<IsForm>) {
  return isOpen
    ? createPortal(
      <div
        className={`fixed top-0 left-0 z-[60] h-screen w-screen ${isLoading ? 'cursor-wait' : ''}`}
      >
        <div className="bg-black opacity-50 h-full w-full absolute top-0 left-0" />
        <div
          className={`bg-white rounded-lg p-6 w-fit flex flex-col gap-6 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${isLoading ? '-z-10' : ''}`}
        >
          {header ? (
            <div className="font-bold text-xl leading-none">
              {header}
              <hr className="border-gray300 mt-4" />
            </div>
          ) : null}
          <div className="text-sm leading-none">
            {content || 'Are you sure you want to continue?'}
          </div>
          <footer className="flex justify-end gap-4">
            <button
              className="border border-error border-solid py-2 px-4 text-error font-bold rounded-full text-sm text-center leading-none disabled:cursor-not-allowed disabled:opacity-60"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="py-2 px-4 bg-success text-light font-bold rounded-full text-sm leading-none disabled:cursor-not-allowed disabled:opacity-60"
              type={formID ? 'submit' : 'button'}
              onClick={onConfirm}
              form={formID}
              disabled={isDisabled || isLoading}
            >
              {formID === 'submit' ? 'Submit' : 'Confirm'}
            </button>
          </footer>
        </div>
      </div>,
      document.body
    )
    : null;
}

export default ConfirmationModal;
